import React from 'react'
import I18n from 'i18n'
import Field from '../common/Field'

export default class KorteVragenlijst extends React.Component {
  render () {
    const values = this.props.data.values
    return (
      <>
        <div className='sport-fields'>
          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v1')}
            value={values.v1}
          />

          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v2')}
            value={values.v2}
          />

          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v3')}
            value={values.v3}
          />

          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v4')}
            value={values.v4}
          />

          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v5')}
            value={values.v5}
          />

          {values.v6 && (
            <Field
              title={I18n.t('questionnaires.korte_vragenlijst.v6')}
              value={Array.isArray(values.v6) ? values.v6.join(', ') : values.v6}
            />
          )}

          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v7')}
            value={values.v7}
          />

          <Field
            title={I18n.t('questionnaires.korte_vragenlijst.v8')}
            value={values.v8}
          />
        </div>
      </>
    )
  }
}
